<m27-dialog #modal class="dialog-final-field-test-report-criteria-component">
    <m27-dialog-header [showClose]="true" [allowMaxSize]="true" (onClose)="isBackButtonEnabled() ? close('Cancel') : closeAll()">
        <div class="title">
            <span>
                <i class="fa fa-table"></i>
                Final Field Test Report Criteria
            </span>
        </div>
    </m27-dialog-header>
    <m27-dialog-body>
        <m27-page-section [caption]="'Crops:'" class="crop-section">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableCrops">
                    <input type="checkbox" automationid="finalFieldTestCropSearch" [id]="'chkF' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chkF' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Years:'" class="year-section">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableYears">
                    <input type="checkbox" automationid="finalFieldTestYearSearch" [id]="'chkF' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chkF' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Permit Statuses:'">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableStatus">
                    <input type="checkbox" automationid="finalFieldTestStatusSearch" [id]="'chkF' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chkF' + cb.Name">{{cb.Name}}</label>
                </span>
                <button automationid="finalFieldTestPermitFind" class="small primary" (click)="searchForPermits()" [disabled]="!validateCanSearchForPermits()">Find Permits</button>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Permits:'" [datagrid]="agGrid" [rowSingle]="'Permit'" [rowPlural]="'Permits'" [hideGridBadges]="isSearching || !hasSearched || totalRowCount === 0" style="height: calc(100% - 140px);">
            <ag-grid-angular #agGrid
                             class="ag-theme-fresh"
                             style="height:100%"
                             [gridOptions]="gridOptions">
            </ag-grid-angular>
        </m27-page-section>
    </m27-dialog-body>
    <m27-dialog-footer>
        <div class="dialog-buttons-left">
            <button *ngFor="let btn of leftButtons; let idx = index" automationid="finalFieldTestBack" class="button" [autofocus]="btn.IsPrimary" [ngClass]="{'primary' : btn.IsPrimary }" (click)="btn.Action()">
                {{btn.Text}}
            </button>
        </div>
        <div class="dialog-buttons-right">
            <div automationid="finalFieldTestReportIdJustCreated" class="badge warn" *ngIf="showReportJustCreatedBadge">Report {{reportIdJustCreated}} Created</div>
            <button *ngFor="let btn of rightButtons; let idx = index" automationid="finalFieldTestRunReports" class="button" [autofocus]="btn.IsPrimary" [disabled]="btn.IsDisabled()" [ngClass]="{'primary' : btn.IsPrimary }" (click)="btn.Action()">
                {{btn.Text}}
            </button>
        </div>
    </m27-dialog-footer>
</m27-dialog>
